import React, { Component, createRef } from 'react';
import { Form, Media, Modal } from 'react-bootstrap';
import { Link, withRouter } from "react-router-dom";
import Layout from "../../components/Layout";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from '../../Languages/DE';
import { callAPI } from "../../helper/apiUtils";
import { EN } from '../../Languages/EN';
import { $crud } from "../../helper/CrudFactory";
import { getDroppedFiles, fileFingerprint } from "../../utils/composerUtils";
import { isVideoFile, isNativeVideoAttachment } from "../../utils/chatVideo";
import {
    compressArticleVideo,
    mergeArticleVideoMeta,
    postArticleFormData,
    prepareArticleVideoForComposer,
} from "../../utils/articleComposerVideo";
import { compressLocalArticleImages } from "../../utils/compressArticleImage";
import { createPublishProgressTracker, waitUntilArticleVideosReady } from "../../utils/articlePublishProgress";
import ArticlePublishProgress from "../../components/ArticlePublishProgress";
import { ReactComponent as SmilyIcon } from "../../Icons/SmilyDeselected.svg"
import { BASE_URL } from "../../helper/constants";
import Carousel from "react-multi-carousel";
import { Scrollbars } from "react-custom-scrollbars";
import { BsClock } from "react-icons/bs";
import { BsChevronDown } from "react-icons/bs";
import ProjectListDialog from "./Dialogs/ProjectListDialog";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { stripMarkdownFromTitle } from '../../helper/stripMarkdownTitle';
import { pastedArticleToHtml, insertPastedArticleHtml } from '../../utils/articleEditorPaste';
import { convertBranchRole, convertHtmlString, urlify } from '../../helper/convertor';
import { formatScheduleDateTime } from '../../helper/dateTimeFormatter';
import PlayerFeed from '../../components/PlayerFeed';
import ReadMores from '../../components/ReadMores';
import { connect } from "react-redux";
import RCPlayer from '../../components/RCPlayer';
import DepartLocaDialogue from '../Company/Dialogs/DepartLocaDialogue';
import TranslationProgressModal from '../../components/TranslationProgressModal';
import ArticleLanguagePicker, { DEFAULT_ARTICLE_LANGUAGE } from "../../components/ArticleLanguagePicker";
import { canManageCompanyArticle, isDeptAdminMembership } from "../../helper/articleAdminRights";
import "./EditCompanyArticle.css";
const extractUrls = require("extract-urls");

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        backgroundColor: 'rgba(var(--kjuup-accent-rgb), 0.8)'
    };
    return <div className="thumb-style" style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = props => (
    <Scrollbars
        renderThumbHorizontal={renderThumb}
        renderThumbVertical={renderThumb}
        {...props}
    />
);

class EditCompanyArticle extends Component {
    static contextType = LanguageContext;

    constructor(props) {
        super(props);
        this.formScrollRef = createRef(null);
        this.articleMediaRef = createRef(null);
        this._lastDropAt = 0;
        this._lastDropCount = 0;

        this.state = {
            editorState: "",
            buildings: [],
            chars_left: 120,
            article: {
                id: '',
                title: "",
                description: "",
                isEmojiUsed: false,
                uploadType: "",
                file: [],
                link: "",
                buildingId: "",
                product: "",
                prevFiles: []
            },
            // Authoring/source language. Article will not be translated into this language.
            originalLanguage: DEFAULT_ARTICLE_LANGUAGE,
            expand: false,
            preview: false,
            profile: {},
            company: {},
            viewProject: false,
            prevFiles: [],
            _Link: [],
            modalData: [],
            showPlayer: false,
            initialIndex: 0,
            // Schedule Article States
            showScheduleModal: false,
            scheduleDate: new Date(),
            scheduleTime: new Date(),
            hasUserMadeChanges: false,
            originalPublishTime: null,
            originalIsPublished: true,
            // Department/Location States
            departments: [],
            deptLocationId: "",
            isCompanyAdmin: false,
            showDepartModal: false,
            names: "",
            // Discard confirmation modal
            showDiscardConfirm: false,
            // Editor resize state
            editorContentHeight: 150, // Default height in pixels
            isResizing: false,
            showTranslationProgress: false,
            translatingArticleId: null,
            loading: true,
            loadingMode: "initial",
            loadingStep: 1,
            publishProgress: 0,
            publishPhase: "preparing",
            isDragging: false,
            // Inform employees via DM (internal articles only)
            notifyEmployeesViaDm: false,
            loadedArticleDepts: null,
            loadedArticleType: null,
            articleLoadReady: false,
            videoMeta: {},
        }

    }

    getTransitionSteps = () => {
        const { loadingMode } = this.state;
        const strings = this.context?.strings || {};
        if (loadingMode === "posting") {
            const postingDraft = this.isEditingDraft();
            return [
                strings.transition_step_prepare_article || strings.article || "Article",
                strings.transition_step_upload_content || strings.media || "Media",
                postingDraft
                    ? (strings.transition_step_post_article || strings.post || "Post")
                    : (strings.transition_step_update_article || strings.update || "Update"),
            ];
        }
        return [
            strings.transition_step_open_page || strings.Loading || "Loading...",
            strings.transition_step_prepare_editor || strings.preview || "Preview",
        ];
    };

    // Schedule Article Helper Functions
    formatDateTimeToUnix = (date, time) => {
        const scheduledDateTime = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            time.getHours(),
            time.getMinutes(),
            0
        );
        return Math.floor(scheduledDateTime.getTime() / 1000); // Convert to Unix timestamp
    };

    formatDateForInput = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    formatTimeForInput = (time) => {
        const hours = String(time.getHours()).padStart(2, '0');
        const minutes = String(time.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    handleScheduleConfirm = () => {
        const { hasUserMadeChanges, scheduleDate, scheduleTime, article } = this.state;

        // Check if user has made any changes
        if (!hasUserMadeChanges) {
            alert(this.context.isGerm
                ? 'Bitte wÃ¤hlen Sie ein anderes Datum oder eine andere Uhrzeit.'
                : 'Please select a different date or time to schedule the article.');
            return;
        }

        // Combine date and time to create scheduled datetime
        const scheduledDateTime = new Date(
            scheduleDate.getFullYear(),
            scheduleDate.getMonth(),
            scheduleDate.getDate(),
            scheduleTime.getHours(),
            scheduleTime.getMinutes(),
            0
        );

        // Get current time
        const now = new Date();

        // Validate that scheduled time is not earlier than current time
        if (scheduledDateTime < now) {
            alert(this.context.isGerm
                ? 'Bitte wÃ¤hlen Sie ein Datum und eine Uhrzeit, die nicht frÃ¼her als die aktuelle Zeit ist.'
                : 'Please select a date and time that is not earlier than the current time.');
            return;
        }

        // Close modal and stay on edit page
        this.setState({ showScheduleModal: false });
    };

    getDetails = async () => {
        this.setState({ loading: true, loadingMode: "initial", loadingStep: 1 });
        try {
            const regex = /(<a[^>]*>.*?<\/a>)|(https?:\/\/[^\s<>\"]+)/g;
            const id = this.props.match.params.articleId
            // Fetch the raw, untranslated article so the editor shows the
            // authored content in its original language and the language
            // picker reflects the article's stored `originalLanguage`.
            const { data } = await callAPI(`/article/${id}?noTranslation=true`, {}, 'GET')
            this.setState({ loadingStep: 2 });
            
            // Check if data exists and has the expected structure
            if (!data || !data.article || !Array.isArray(data.article) || data.article.length === 0) {
                console.error('Article data not found or invalid structure:', data);
                // Handle the error case - you might want to show an error message or redirect
                this.setState({ 
                    error: 'Article not found or failed to load',
                    loading: false 
                });
                return;
            }
            
            let article = data.article[0]
        
        // Load existing department/location data if available
        if (article.deptLocation && article.deptLocation.length > 0) {
            const deptLocationIds = article.deptLocation.map(dept => dept.deptLocation);
            const deptLocationNames = article.deptLocation.map(dept => dept.departmentLocation).join(', ');
            this.setState({ 
                deptLocationId: deptLocationIds,
                names: deptLocationNames
            });
        }

        this.setState({
            loadedArticleDepts: article.deptLocation || [],
            loadedArticleType: article.articleType,
            articleLoadReady: true,
        }, () => {
            this.denyIfDeptAdminCannotEdit();
        });
        
        await this.getBase64Files(article.uploadUrl);
        const html = (article && article.description) ? article.description?.replace(regex, (match, p1, p2) => {
            if (p1) {
                return p1;
            } else {
                if (p2) {
                    return `<a href="${p2}">${p2}</a>`;
                }
                return ""
            }
        }) : ""
        const contentBlock = htmlToDraft(html);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            this.setState(state => {
                return {
                    ...state,
                    article: {
                        id: article.id,
                        title: stripMarkdownFromTitle(article.title || '').slice(0, 120),
                        isEmojiUsed: article.isEmojiUsed ?? false,
                        uploadType: article.uploadType,
                        prevFiles: article.uploadUrl,
                        link: article.link,
                        buildingId: article.buildingId,
                        product: article.product && article.product !== "null" ? article.product : "",
                        file: article.uploadUrl,
                    },
                    originalLanguage: (article.originalLanguage || DEFAULT_ARTICLE_LANGUAGE).toString().toLowerCase(),
                    editorState,
                    chars_left: 120 - stripMarkdownFromTitle(article.title || '').slice(0, 120).length
                }
            })

            // Load existing schedule data
            if (article.publishedAt) {
                const publishDate = new Date(Number(article.publishedAt) * 1000);
                const publishTimeUnix = Number(article.publishedAt)
                this.setState({
                    scheduleDate: publishDate,
                    scheduleTime: publishDate,
                    originalPublishTime: publishTimeUnix,
                    // Only set hasUserMadeChanges to true if user has actually made changes, not by default
                    hasUserMadeChanges: false
                });
            }

            if (article.isPublished !== undefined) {
                this.setState({ originalIsPublished: article.isPublished });
            }

            if (article && article.description) {
                this.setParam(
                    "description",
                    convertHtmlString(
                        article.description?.replace(regex, (match, p1, p2) => {
                            if (p1) {
                                return p1;
                            } else {
                                return `<a href="${p2}">${p2}</a>`;
                            }
                        })
                    )
                );
                setTimeout(() => {
                    this._checkForLink(article.description)
                }, 500)
            }
        }
        this.setState({ loadingStep: 2, loading: false });
        } catch (error) {
            console.error('Error in getDetails:', error);
            this.setState({ 
                error: 'Failed to load article details',
                loading: false 
            });
        }
    }


    toggleSmily = (value) => {
        this.setState({ article: { ...this.state.article, isEmojiUsed: !value } });
    }
    expandArticle = () => {
        this.setState({ expand: true })
    }

    removeImage = (file, index) => {
        console.log(index)
        const article = this.state.article;
        if (article.prevFiles.length > 0) {
            const files = article.prevFiles.splice(index + 1, 1);
            const prevFiles = this.state.prevFiles.splice(index + 1, 1);
            this.setState({ prevFiles: prevFiles })
            article.prevFiles = files;
        } else {
            const files = article.file.splice(index + 1, 1);
        }
        this.setState({ article: article })
    }


    removeAllFields = async () => {
        if (this.state.article.title) {
            this.setState({ showDiscardConfirm: true });
        }
        else{
            this.props.history.goBack()
        }
    }

    confirmDiscardArticle = () => {
        this.setState({ showDiscardConfirm: false });
        this.props.history.goBack();
    }

    cancelDiscardArticle = () => {
        this.setState({ showDiscardConfirm: false });
    }

    navigateAfterSave = () => {
        const fromFeed = this.props?.location?.state?.fromFeeds;
        const articleType = this.state.articleType;
        const isInternal = this.props?.location?.state?.from === "internal" || articleType == 1;
        if (fromFeed) {
            this.props.history.push({
                pathname: '/articles',
                state: { isPosted: true, isExternalSelected: 0, internal: !!isInternal }
            });
            return;
        }
        const id = this.state.company?.id || this.props.match?.params?.id;
        this.props.history.push({
            pathname: id ? "/cockpit" : "/articles",
            search: id ? `?tab=company&company=${encodeURIComponent(id)}` : undefined,
        });
    }


    setParam = (key, value) => {
        this.setState(state => {
            return {
                ...state,
                article: {
                    ...state.article,
                    [key]: value
                }
            }
        })
    }


    handleWordCount = async (event) => {
        const maxLen = 120;
        const cleaned = stripMarkdownFromTitle(event.target.value).slice(0, maxLen);
        const charCount = cleaned.length;
        this.setState({
            chars_left: maxLen - charCount
        })
        await this.setParam('title', cleaned)
    }


    get = async () => {

        const { data } = await callAPI('/building/my', {}, 'GET')
        this.setState({
            buildings: data.buildings
        })

        console.log(data)
    }

    componentDidMount() {
        this.setState({ articleType: this.props?.location?.state?.articleType == 1 ? 1 : 0 })
        this.get()
        this.getProfile();
        this.getCompanyDetails()
        this.getDetails()

    }

    getProfile = async () => {
        const { data } = await callAPI(`/user/profile`, {}, 'GET')
        console.log(data)
        this.setState({ profile: data.profile })
    }

    _getDepartmentAndLocations = async () => {
        const id = this.props.match.params.id;
        const { data } = await callAPI(`/company/getDeptLocation/${id}`, {}, "GET");
        if (data.status) {
            this.setState({ departments: data.data.getCompanyDept })
        }
    }

    getCompanyDetails = async () => {
        const id = this.props.match.params.id
        const { data } = await callAPI(`/company/${id}/profile`, {}, "GET");
        if (data.status) {
            console.log('---data', data)
            this.setState({ company: data.profile }, () => {
                this.denyIfDeptAdminCannotEdit();
            })
            if (data.profile.position == "COMPANY ADMIN") {
                this.setState({ isCompanyAdmin: true })
            }
            if (data.profile.position == "COMPANY_DEPARTMENT_ADMIN") {
                this.setState((prev) => ({
                    deptLocationId: prev.deptLocationId && (
                        Array.isArray(prev.deptLocationId)
                            ? prev.deptLocationId.length > 0
                            : true
                    )
                        ? prev.deptLocationId
                        : [data.profile.deptLocationId]
                }))
            }
            this._getDepartmentAndLocations()
        }
    }

    denyIfDeptAdminCannotEdit = () => {
        const { company, articleLoadReady, loadedArticleDepts, loadedArticleType } = this.state;
        if (!articleLoadReady || !company || !isDeptAdminMembership(company)) {
            return;
        }
        const allowed = canManageCompanyArticle(
            { deptLocation: loadedArticleDepts, articleType: loadedArticleType },
            company,
            { isInternal: !!(loadedArticleType === true || loadedArticleType === 1 || loadedArticleType === "1") }
        );
        if (allowed) {
            return;
        }
        $crud.notify({
            type: "error",
            message: this.context.isGerm
                ? "Du kannst nur Artikel deiner Abteilung bearbeiten."
                : "You can only edit articles for your department.",
        });
        this.props.history.goBack();
    }


    isPdfFile = (file) => {
        if (!file) return false;
        if (file.type === 'application/pdf') return true;
        const name = file.name || '';
        return /\.pdf$/i.test(name);
    };

    isImageFile = (file) => {
        if (!file) return false;
        return (
            file.type === 'image/jpeg' ||
            file.type === 'image/png' ||
            file.type === 'image/jpg' ||
            /\.(jpe?g|png)$/i.test(file.name || '')
        );
    };

    static MAX_ARTICLE_FILE_BYTES = 25 * 1024 * 1024;

    notifyIfFilesTooLarge = (files) => {
        const oversized = (files || []).some((f) =>
            f && !isVideoFile(f) && typeof f.size === 'number' && f.size > EditCompanyArticle.MAX_ARTICLE_FILE_BYTES
        );
        if (!oversized) return false;
        $crud.notify({
            type: 'error',
            message: this.context.strings.max_file_size_exceeded_25mb || 'Max. size of 25MB exceeded. Please choose a smaller file.',
        });
        return true;
    };

    decorateArticleFile = async (file) => {
        if (isVideoFile(file)) {
            const prepared = await prepareArticleVideoForComposer(file);
            if (!prepared.ok) {
                $crud.notify({
                    type: 'error',
                    message: this.context.strings[prepared.errorKey] || prepared.errorKey,
                });
                return null;
            }
            return prepared;
        }
        const blobUrl = file.url || URL.createObjectURL(file);
        file.url = blobUrl;
        file.fileUrl = blobUrl;
        file.local = true;
        file.originalName = file.name;
        file.attachedFileName = file.name;
        if (this.isPdfFile(file)) {
            file.isPdf = true;
            file.fileType = 'doc';
        } else {
            file.fileType = 'image';
        }
        return { ok: true, file, needsCompress: false };
    };

    patchArticleVideoMeta = (clientId, patch) => {
        if (!clientId) return;
        this.setState((state) => ({
            videoMeta: {
                ...state.videoMeta,
                [clientId]: { ...(state.videoMeta[clientId] || {}), ...patch },
            },
        }));
    };

    enqueueArticleVideoCompress = (file) => {
        if (!file?.clientId || !file.processing) return;
        this._videoCompressChain = (this._videoCompressChain || Promise.resolve())
            .then(() => this.compressOneArticleVideo(file))
            .catch(() => {});
    };

    compressOneArticleVideo = async (file) => {
        const clientId = file.clientId;
        const compressed = await compressArticleVideo(file, {
            isStale: () => !(this.state.article.file || []).some((f) => f.clientId === clientId),
            onProgress: (pct) => this.patchArticleVideoMeta(clientId, {
                processing: true,
                uploading: false,
                progress: pct,
            }),
        });
        if (!compressed) return;
        await new Promise((resolve) => {
            this.setState((state) => ({
                videoMeta: {
                    ...state.videoMeta,
                    [clientId]: { processing: false, uploading: false, progress: 0 },
                },
                article: {
                    ...state.article,
                    file: (state.article.file || []).map((f) => (f.clientId === clientId ? compressed : f)),
                },
            }), resolve);
        });
    };

    appendDecoratedArticleFiles = (previewFiles, videosToCompress) => {
        this.setState((state) => {
            const existing = new Set((state.article.file || []).map(fileFingerprint));
            const unique = previewFiles.filter((f) => {
                const key = fileFingerprint(f);
                if (existing.has(key)) return false;
                existing.add(key);
                return true;
            });
            if (unique.length === 0) return null;
            const videoMeta = { ...state.videoMeta };
            unique.forEach((f) => {
                if (!f.clientId) return;
                videoMeta[f.clientId] = {
                    processing: !!f.processing,
                    uploading: false,
                    progress: 0,
                };
            });
            return {
                prevFiles: [],
                videoMeta,
                article: {
                    ...state.article,
                    prevFiles: [],
                    file: [...state.article.file, ...unique],
                },
            };
        }, () => {
            const present = new Set((this.state.article.file || []).map((f) => f.clientId));
            videosToCompress
                .filter((file) => file.clientId && present.has(file.clientId))
                .forEach((file) => this.enqueueArticleVideoCompress(file));
            this.scrollArticleMediaIntoView();
        });
    };

    scrollArticleMediaIntoView = () => {
        const reveal = () => {
            const media = this.articleMediaRef.current;
            const scroller = this.formScrollRef.current;
            if (!media || !scroller) return;
            const mediaRect = media.getBoundingClientRect();
            const scrollerRect = scroller.getBoundingClientRect();
            const overflowBottom = mediaRect.bottom - scrollerRect.bottom + 12;
            if (overflowBottom > 0) {
                scroller.scrollBy({ top: overflowBottom, behavior: 'smooth' });
            }
        };
        requestAnimationFrame(() => requestAnimationFrame(reveal));
    };

    handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: true });
    };

    handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.currentTarget && !e.currentTarget.contains(e.relatedTarget)) {
            this.setState({ isDragging: false });
        }
    };

    handleDrop = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: false });

        const droppedFiles = getDroppedFiles(e.dataTransfer);
        if (droppedFiles.length === 0) return;

        const now = Date.now();
        if (now - this._lastDropAt < 400 && droppedFiles.length <= this._lastDropCount) return;
        this._lastDropAt = now;
        this._lastDropCount = droppedFiles.length;

        const acceptedFiles = droppedFiles.filter(f =>
            this.isImageFile(f) || this.isPdfFile(f) || isVideoFile(f)
        );
        if (acceptedFiles.length === 0) {
            $crud.notify({
                type: 'error',
                message: this.context.strings.unsupported_file_type || 'Unsupported file type. Only images, videos and PDFs are allowed.',
            });
            return;
        }
        const nonVideos = acceptedFiles.filter((f) => !isVideoFile(f));
        if (this.notifyIfFilesTooLarge(nonVideos)) return;

        const previewFiles = [];
        const videosToCompress = [];
        for (const file of acceptedFiles) {
            const decorated = await this.decorateArticleFile(file);
            if (!decorated || !decorated.file) continue;
            previewFiles.push(decorated.file);
            if (decorated.needsCompress) videosToCompress.push(decorated.file);
        }
        if (previewFiles.length === 0) return;
        this.appendDecoratedArticleFiles(previewFiles, videosToCompress);
    };

    choseFiles = async (e) => {
        e.preventDefault();
        let file = await $crud.chooseFile();
        if (!file) return;
        const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '');
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
            || /\.(jpe?g|png)$/i.test(file.name || '');
        if (!isPdf && !isImage && !isVideoFile(file)) {
            $crud.notify({
                type: 'error',
                message: this.context.strings.unsupported_file_type || 'Unsupported file type. Only images, videos and PDFs are allowed.',
            });
            return;
        }
        if (!isVideoFile(file) && this.notifyIfFilesTooLarge([file])) return;
        const decorated = await this.decorateArticleFile(file);
        if (!decorated || !decorated.file) return;
        this.appendDecoratedArticleFiles([decorated.file], decorated.needsCompress ? [decorated.file] : []);
    }
    handlePreview = () => {
        const { articleType } = this.state;

        if (!this.state.article.title) {
            $crud.notify({
                type: "error",
                message: "Please enter article title first.",
            });
            return;
        }
        
        // Check if department/location is selected for internal articles
        if (this.state.isCompanyAdmin && this.state.departments.length > 0 && articleType == 1) {
            if (!this.state.deptLocationId || this.state.deptLocationId.length === 0) {
                $crud.notify({
                    type: 'error',
                    message: "Please select department/location"
                });
                return;
            }
        }
        
        this.setState({ preview: true });
    }

    isEditingDraft = () => {
        const { originalIsPublished, originalPublishTime } = this.state;
        const unpublished =
            originalIsPublished === false ||
            originalIsPublished === 0 ||
            originalIsPublished === "false" ||
            originalIsPublished === "0";
        if (!unpublished) {
            return false;
        }
        const publishAt = Number(originalPublishTime);
        return !(Number.isFinite(publishAt) && publishAt > 0);
    }

    handleSaveDraft = () => {
        if (!this.isEditingDraft()) {
            return;
        }
        if (!this.state.article.title || !this.state.article.title.trim()) {
            $crud.notify({
                type: "error",
                message: this.context.strings.please_enter_article_title || "Please enter article title first.",
            });
            return;
        }
        this.postArticle({ saveAsDraft: true });
    }

    getBase64Files = async (images) => {
        if (!images || !images.length) return;
        images.forEach((image) => {
            if (!image || isNativeVideoAttachment(image) || this.isPdfFile(image)) return;
            const path = image.fileUrl;
            if (!path || typeof path !== 'string') return;
            this.toDataURL(BASE_URL + path, (u) => {
                const file = this.dataURLtoFile(u, image.attachedFileName || 'file.png')
                this.setState(state => {
                    return {
                        ...state,
                        prevFiles: [...state.prevFiles, file]
                    }
                })
            })
        })
    }

    dataURLtoFile(dataurl, filename) {

        var arr = dataurl?.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    toDataURL = (url, callback) => {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };


    postArticle = async (options = {}) => {
        if (this.state.loading && this.state.loadingMode === "posting") return;
        const saveAsDraft = !!(options && options.saveAsDraft) && this.isEditingDraft();
        const regex = /(<a[^>]*>.*?<\/a>)|(https?:\/\/[^\s<>\"]+)/g;
        const { article, hasUserMadeChanges, scheduleDate, scheduleTime, originalPublishTime, originalIsPublished, deptLocationId, departments, articleType } = this.state;
        if (this.notifyIfFilesTooLarge(article.file)) return;

        this.setState({
            loading: true,
            loadingMode: "posting",
            loadingStep: 1,
            publishProgress: 4,
            publishPhase: "preparing",
        });

        const tracker = createPublishProgressTracker({
            files: article.file,
            onUpdate: ({ phase, percent }) => {
                this.setState({ publishPhase: phase, publishProgress: percent, loadingStep: phase === "finishing" ? 3 : 2 });
            },
        });
        let finishingPulse;

        const finishUpdate = (res, { notify } = {}) => {
            if (notify && res && res.message) {
                $crud.notify({
                    type: res.status ? "success" : 'error',
                    message: res.message
                });
            }
            if (res.status && res.article?.id) {
                this.setState({
                    loading: false,
                    showTranslationProgress: false,
                    translatingArticleId: res.article.id,
                    videoMeta: {},
                    publishProgress: 100,
                });
                this.navigateAfterSave();
            } else {
                if (!notify) {
                    $crud.notify({
                        type: res.status ? "success" : 'error',
                        message: res.message
                    });
                }
                this.setState({ loading: false });
                if (res.status) {
                    this.navigateAfterSave();
                }
            }
        };

        try {
            if (tracker.hasVideo) {
                tracker.setStage("compressing", 4);
                await waitUntilArticleVideosReady({
                    getChain: () => this._videoCompressChain || Promise.resolve(),
                    getFiles: () => this.state.article.file,
                    getVideoMeta: () => this.state.videoMeta,
                    onProgress: (pct) => tracker.setStage("compressing", pct),
                });
            }

            let files = this.state.article.file || [];
            if (tracker.hasImages) {
                tracker.setStage("media", 2);
                files = await compressLocalArticleImages(files, {
                    onProgress: (pct) => tracker.setStage("media", pct),
                });
            }

            let formData = new FormData()
            formData.append('id', article.id)
            formData.append('title', stripMarkdownFromTitle(article.title))
            formData.append('description', article.description ? article.description?.replace(regex, (match, p1, p2) => {
                if (p1) return p1;
                return `<a href="${p2}">${p2}</a>`;
            }) : "")
            formData.append('isEmojiUsed', article.isEmojiUsed)
            formData.append('uploadType', (files.length > 0) ? 'media' : 'none')
            formData.append('link', '')
            formData.append('buildingId', article.buildingId)
            formData.append('product', article.product)
            formData.append(
                'originalLanguage',
                (this.state.originalLanguage || DEFAULT_ARTICLE_LANGUAGE).toLowerCase()
            )

            if (articleType == 1) {
                if (this.props?.location?.state?.deptLocationId || (deptLocationId && deptLocationId.length > 0)) {
                    let ids = deptLocationId ? (Array.isArray(deptLocationId) ? deptLocationId : [deptLocationId]) : [this.props?.location?.state?.deptLocationId]
                    for (let i = 0; i < ids.length; i++) {
                        formData.append(`deptLocation`, ids[i]);
                    }
                }
                else if (articleType == 0 && departments.length > 0) {
                    for (let i = 0; i < departments.length; i++) {
                        formData.append(`deptLocation`, departments[i].id);
                    }
                }
                formData.append('notifyEmployeesViaDm', String(!!this.state.notifyEmployeesViaDm));
            }

            if (saveAsDraft) {
                formData.append('isPublished', 'false');
            } else if (this.isEditingDraft()) {
                const isPublished = !hasUserMadeChanges;
                formData.append('isPublished', isPublished.toString());
                if (!isPublished) {
                    const publishTime = this.formatDateTimeToUnix(scheduleDate, scheduleTime);
                    formData.append('publishTime', publishTime.toString());
                }
            } else {
                const isPublished = hasUserMadeChanges ? false : originalIsPublished;
                formData.append('isPublished', isPublished.toString());

                if (!isPublished && hasUserMadeChanges) {
                    const publishTime = this.formatDateTimeToUnix(scheduleDate, scheduleTime);
                    formData.append('publishTime', publishTime.toString());
                } else if (!isPublished && originalPublishTime) {
                    formData.append('publishTime', originalPublishTime.toString());
                } else if (isPublished && originalPublishTime) {
                    formData.append('publishTime', '');
                }
            }

            let _serverIm = []
            let _localIm = []
            for (let obj of files) {
                if (obj.local) {
                    _localIm.push(obj)
                } else {
                    _serverIm.push({
                        fileUrl: obj.fileUrl,
                        fileType: obj.fileType,
                        attachedFileName: obj.attachedFileName || obj.originalName || obj.name || null,
                        thumbnailUrl: obj.thumbnailUrl || null,
                    })
                }
            }
            formData.append('fileList', JSON.stringify(_serverIm))
            formData.append('hasNewFiles', _localIm.length > 0 ? 'true' : 'false')
            _localIm.forEach((item) => {
                formData.append('file', item, item.name || item.attachedFileName || item.originalName);
            })

            const localIds = _localIm.filter((f) => f?.clientId && isVideoFile(f)).map((f) => f.clientId);
            if (localIds.length) {
                const nextMeta = { ...this.state.videoMeta };
                localIds.forEach((id) => {
                    nextMeta[id] = { processing: false, uploading: true, progress: 0 };
                });
                this.setState({ videoMeta: nextMeta });
            }

            tracker.setStage("uploading", 2);
            const res = await postArticleFormData('/article/updateArticle', formData, {
                onUploadProgress: (evt) => {
                    if (!evt.total) return;
                    const pct = Math.round((evt.loaded * 100) / evt.total);
                    tracker.setStage("uploading", pct);
                    if (localIds.length) {
                        this.setState((state) => {
                            const videoMetaNext = { ...state.videoMeta };
                            localIds.forEach((id) => {
                                videoMetaNext[id] = {
                                    processing: false,
                                    uploading: true,
                                    progress: pct >= 100 ? 100 : pct,
                                };
                            });
                            return { videoMeta: videoMetaNext };
                        });
                    }
                    if (pct >= 100 && !finishingPulse) {
                        let tick = 12;
                        finishingPulse = setInterval(() => {
                            tick = Math.min(88, tick + 7);
                            tracker.setStage("finishing", tick);
                        }, 350);
                    }
                },
            });
            if (finishingPulse) clearInterval(finishingPulse);
            this.setState({ publishProgress: 100, publishPhase: "finishing", loadingStep: 3 });
            finishUpdate(res || {}, { notify: true });
        } catch (e) {
            if (finishingPulse) clearInterval(finishingPulse);
            $crud.notify({
                type: 'error',
                message: e.message || this.context.strings.article_publish_uploading || 'Uploading…',
            });
            this.setState({ loading: false, publishProgress: 0 });
        }
    }
    handlePastedText = (text, html) => {
        const pastedHtml = pastedArticleToHtml(text, html);
        if (!pastedHtml) return false;
        const nextState = insertPastedArticleHtml(this.state.editorState, pastedHtml);
        if (!nextState) return false;
        this.onEditorStateChange(nextState);
        return true;
    };

    onEditorStateChange = (editorState) => {
        const regex = /(<a[^>]*>.*?<\/a>)|(https?:\/\/[^\s<>\"]+)/g;
        let currentContentAsHTML = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        this.setState(state => {
            return {
                ...state,
                article: {
                    ...state.article,
                    description: currentContentAsHTML,
                },
                editorState,
            }
        })
        this.setParam(
            "description",
            convertHtmlString(
                currentContentAsHTML
                    ?.replace(regex, (match, p1, p2) => {
                        if (p1) {
                            return p1;
                        } else {
                            return `<a href="${p2}">${p2}</a>`;
                        }
                    })
            )
        );
        this._checkForLink(currentContentAsHTML);
    };
    
    handleResizeStart = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const startY = e.clientY;
        const startHeight = this.state.editorContentHeight;
        
        this.setState({ isResizing: true });
        
        const handleMouseMove = (moveEvent) => {
            moveEvent.preventDefault();
            moveEvent.stopPropagation();
            const deltaY = moveEvent.clientY - startY;
            const newHeight = Math.round(startHeight + deltaY);
            const minHeight = 150;
            const maxHeight = 600;
            
            if (newHeight >= minHeight && newHeight <= maxHeight) {
                this.setState({ editorContentHeight: newHeight });
            }
        };
        
        const handleMouseUp = (upEvent) => {
            upEvent.preventDefault();
            this.setState({ isResizing: false });
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }

    _checkForLink = (currentContentAsHTML) => {
        let datax = extractUrls(currentContentAsHTML);
        datax = datax && Array.isArray(datax) ? datax.map(e => { return e?.replace('&quot', '') }) : datax
        let data = [...new Set(datax)];
        let videoLinks = []
        if (data && data.length > 0) {
            for (let obj of data) {
                let x = { href: obj }
                let lnk = obj
                if (lnk.match('vimeo')) {
                    x.videoType = 'vimeo'
                    videoLinks.push(x)
                }
                if (lnk.match('youtube') || lnk.match('youtu')) {
                    x.videoType = 'youtube'
                    videoLinks.push(x)
                }
            }
        }
        this.setState({ _Link: videoLinks });
    }
    render() {
        const regex = /(<a[^>]*>.*?<\/a>)|(https?:\/\/[^\s<>\"]+)/g;
        let { _Link, article, articleType, modalData, initialIndex, showPlayer, videoMeta, loading } = this.state
        const displayLinks = [..._Link, ...mergeArticleVideoMeta(article.file || [], videoMeta)]
        return (
            <React.Fragment>
                <div className="following edit-company-article">
                    {loading && this.state.loadingMode === "posting" && (
                        <ArticlePublishProgress
                            percent={this.state.publishProgress}
                            phase={this.state.publishPhase}
                            strings={this.context.strings || {}}
                            isInternal={articleType == 1}
                        />
                    )}
                    {loading && this.state.loadingMode !== "posting" && (
                        <div className="article-transition-screen">
                            <div className="article-transition-card">
                                {this.getTransitionSteps().map((stepLabel, index) => {
                                    const isDone = this.state.loadingStep > index + 1;
                                    const isActive = this.state.loadingStep === index + 1;
                                    return (
                                        <div
                                            key={stepLabel}
                                            className={`article-transition-step ${isActive ? "article-transition-step-active" : ""}`}
                                        >
                                            <span className="article-transition-step-icon">
                                                {isDone ? (
                                                    <span className="material-symbols-outlined article-transition-check">check_circle</span>
                                                ) : (
                                                    <span className={`article-transition-step-number ${isActive ? "article-transition-step-number-active" : ""}`}>
                                                        {index + 1}
                                                    </span>
                                                )}
                                            </span>
                                            <span>{stepLabel}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {!this.state.preview ?
                        <div className={`${articleType == 1 ? "main_heading main_heading-internal" : "main_heading"} edit-company-article__header`}>
                            <div className="edit-company-article__header-left">
                                {/* Legacy back button removed */}
                            </div>
                            <button
                                type="button"
                                onClick={() => this.removeAllFields()}
                                className={`kj-btn kj-btn--icon kj-btn--neutral${articleType == 1 ? ' kj-btn--internal' : ''} edit-company-article__btn-gap`}
                                data-article-type={articleType}>
                                <span className="material-symbols-outlined close-icon">close</span>
                            </button>
                        </div>
                        :
                        <></>
                    }
                    <div ref={this.formScrollRef} className="article-form-scroll-container edit-company-article__form-scroll">
                        {
                            !this.state.preview &&
                            <div>
                                <div className="article_form">
                                    <div className="form-bottom">
                                        <Form className="add_company_from">
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Control type="text" rows={1}
                                                    className={`form-control article-title-input ${articleType == 0 ? 'article-title-input-external' : ''}`}
                                                    maxLength="120"
                                                    value={this.state.article.title}
                                                    onChange={this.handleWordCount}
                                                    placeholder={this.context.strings.title}
                                                    data-article-type={articleType} />
                                                <Form.Text
                                                    className="text-muted"> {this.state.chars_left} {this.context.strings.characters_remaining}</Form.Text>
                                            </Form.Group>
                                            <Form.Group controlId="formBasic">
                                                <div className="resizable-editor-container">
                                                    <Editor
                                                        stripPastedStyles={true}
                                                        editorState={this.state.editorState}
                                                        toolbar={{
                                                            options: ["inline", "list"],
                                                            inline: {
                                                                inDropdown: false,
                                                                options: ["bold", "italic", "underline"],
                                                            },
                                                            list: {
                                                                inDropdown: false,
                                                                options: ["unordered", "ordered"]
                                                            },
                                                        }}
                                                        editorClassName="demo-editor"
                                                        toolbarStyle={{
                                                            border: 'none'
                                                        }}
                                                        wrapperStyle={{
                                                            border: 'none'
                                                        }}
                                                        editorStyle={{
                                                            border: 'none',
                                                            fontSize: "var(--kjuup-type-body)",
                                                            color: '#737373',
                                                            minHeight: this.state.editorContentHeight + 'px',
                                                            height: this.state.editorContentHeight + 'px',
                                                            overflowY: 'auto',
                                                            overflowX: 'hidden',
                                                            position: 'relative'
                                                        }}
                                                        toolbarClassName={this.props?.location?.state?.articleType == 1 ? "toolbar-class custom-richtext-internal" : "toolbar-class custom-richtext"}
                                                        onEditorStateChange={this.onEditorStateChange}
                                                        handlePastedText={this.handlePastedText}
                                                    />
                                                    <div
                                                        className="editor-resize-handle edit-company-article__resize-handle"
                                                        onMouseDown={this.handleResizeStart}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="articleOriginalLanguage" className="select_coustom">
                                                <Form.Label className="d-block mb-1 edit-company-article__lang-label">
                                                    {this.context.strings.article_original_language}
                                                </Form.Label>
                                                <ArticleLanguagePicker
                                                    id="articleOriginalLanguage"
                                                    value={this.state.originalLanguage}
                                                    onChange={(code) => this.setState({ originalLanguage: code })}
                                                />
                                                <Form.Text className="text-muted edit-company-article__lang-hint">
                                                    {this.context.strings.article_original_language_info}
                                                </Form.Text>
                                            </Form.Group>
                                            {(this.state.departments && this.state.departments.length > 0 && this.state.isCompanyAdmin && articleType == 1) ?
                                                <Form.Group className="select_coustom border-0 hello">
                                                    <a
                                                        className="register_role pointer text-truncate position-relative"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.setState({ showDepartModal: true })
                                                        }}
                                                    >
                                                        {!this.state.names && (
                                                            <span className="edit-company-article__dep-label">
                                                                {this.context.strings.dep_loc}{" "}
                                                            </span>
                                                        )}
                                                        {this.state.names && <span className="edit-company-article__dep-label">{this.state.names}</span>}
                                                        <BsChevronDown />
                                                    </a>
                                                </Form.Group>
                                                :
                                                <></>
                                            }
                                            {articleType == 1 && (
                                                <Form.Group className="border-0 mt-2 mb-1 text-left">
                                                    <div
                                                        className={`article-notify-dm ${this.state.notifyEmployeesViaDm ? 'is-selected' : ''}`}
                                                        onClick={() => this.setState({ notifyEmployeesViaDm: !this.state.notifyEmployeesViaDm })}
                                                    >
                                                        <span className="article-notify-dm-check" aria-hidden="true" />
                                                        <span className="article-notify-dm-copy">
                                                            <span className="article-notify-dm-label">
                                                                {this.context.strings.notify_employees_via_dm
                                                                    || "Inform employees via direct message"}
                                                            </span>
                                                            <span className="article-notify-dm-hint">
                                                                {this.context.strings.notify_employees_via_dm_hint_edit
                                                                    || this.context.strings.notify_employees_via_dm_hint
                                                                    || "Sends a chat message from your account to employees of the selected departments, locations or teams about the changes."}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </Form.Group>
                                            )}
                                            {/* Add Images / PDFs Section with Drag and Drop */}
                                            <div ref={this.articleMediaRef}>
                                            <div
                                                onClick={() => this.choseFiles({ preventDefault: () => {} })}
                                                onDragOver={this.handleDragOver}
                                                onDragEnter={this.handleDragEnter}
                                                onDragLeave={this.handleDragLeave}
                                                onDrop={this.handleDrop}
                                                className={`article-image-dropzone${this.state.isDragging ? ' article-image-dropzone-active' : ''} edit-company-article__dropzone${this.state.isDragging ? ' edit-company-article__dropzone--dragging' : ''}${((this.state.originalPublishTime && !this.state.originalIsPublished) || (this.state.hasUserMadeChanges && this.state.scheduleDate && this.state.scheduleTime)) ? ' edit-company-article__dropzone--scheduled' : ''}`}>
                                                <span 
                                                    className="material-symbols-outlined form-add-icon edit-company-article__dropzone-icon"
                                                    data-article-type={articleType}
                                                >{this.state.isDragging ? 'file_download' : 'add_circle'}</span>
                                                <span className="edit-company-article__dropzone-label">
                                                    {this.state.isDragging
                                                        ? (this.context.strings.drop_files_here || this.context.strings.drop_images_here || "Drop files here")
                                                        : (this.context.strings.add_images_or_pdf || this.context.strings.add_images)}
                                                </span>
                                                <span className="edit-company-article__dropzone-hint">
                                                    {this.context.strings.drag_and_drop_hint_pdf || this.context.strings.drag_and_drop_hint || "or drag & drop images or PDFs here"}
                                                </span>
                                            </div>
                                            {displayLinks && displayLinks.length > 0 &&
                                                <PlayerFeed
                                                    Links={displayLinks}
                                                    article={article}
                                                    isC
                                                    isInternal={articleType == 1}
                                                    removeImage={(i) => {
                                                        let { article, videoMeta } = this.state
                                                        const target = displayLinks[i];
                                                        let ind = article.file.findIndex(e =>
                                                            (target?.clientId && e.clientId === target.clientId) ||
                                                            e.fileUrl == target.fileUrl
                                                        );
                                                        if (ind !== -1) {
                                                            const removed = article.file[ind];
                                                            if (removed?.url?.startsWith('blob:')) URL.revokeObjectURL(removed.url);
                                                            let x = { ...article }
                                                            let b = [...x.file]
                                                            b.splice(ind, 1)
                                                            x = { ...x, file: b }
                                                            const nextMeta = { ...videoMeta };
                                                            if (removed?.clientId) delete nextMeta[removed.clientId];
                                                            this.setState({ article: x, videoMeta: nextMeta })
                                                        }
                                                    }}
                                                />
                                            }
                                            </div>

                                            {/* Scheduled Note - Show at bottom when article is scheduled or user has made changes */}
                                            {((this.state.originalPublishTime && !this.state.originalIsPublished) || (this.state.hasUserMadeChanges && this.state.scheduleDate && this.state.scheduleTime)) && (
                                                <div 
                                                    className={`schedule-note-card ${articleType == 1 ? 'schedule-note-card-internal' : 'schedule-note-card-external'}`}
                                                    onClick={() => this.setState({ showScheduleModal: true })}>
                                                    <div className={`schedule-note-icon-wrapper ${articleType == 1 ? 'schedule-note-icon-wrapper-internal' : 'schedule-note-icon-wrapper-external'}`}>
                                                        <span className={`material-symbols-outlined schedule-note-icon ${articleType == 1 ? 'schedule-note-icon-internal' : 'schedule-note-icon-external'}`}>
                                                            schedule
                                                        </span>
                                                    </div>
                                                    <div className="schedule-note-content">
                                                        <p className="schedule-note-label">
                                                            {this.context.strings.scheduled_for_publication}
                                                        </p>
                                                        <p className="schedule-note-datetime">
                                                            {this.state.hasUserMadeChanges ? (
                                                                formatScheduleDateTime(this.state.scheduleDate, this.state.scheduleTime, this.context.language || (this.context.isGerm ? 'de' : 'en'), this.context.strings?.at_time)
                                                            ) : (
                                                                formatScheduleDateTime(new Date(this.state.originalPublishTime * 1000), null, this.context.language || (this.context.isGerm ? 'de' : 'en'), this.context.strings?.at_time)
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.state.preview &&
                            <div>
                                <div className="article-live-preview">
                                    <Media className="article-author-media">
                                        {
                                            this.props?.location?.state?.from != 'internal' ? (
                                                <img
                                                    width={40}
                                                    height={40}
                                                    className="mr-3 news_profile edit-company-article__author-img"
                                                    src={this.state.company.logo ? BASE_URL + this.state.company.logo : this.state.company.avatar ? BASE_URL + this.state.company.avatar : process.env.PUBLIC_URL + "/assets/img/Companies-No-Image.svg"}
                                                    alt="Generic placeholder"
                                                />
                                            ) : (
                                                <img
                                                    width={25}
                                                    height={25}
                                                    className="mr-3 news_profile edit-company-article__author-img edit-company-article__author-img--round"
                                                    src={
                                                        this.state.article.postedByImage ? BASE_URL + this.state.article.postedByImage :
                                                        this.state.article.userAvatar ? BASE_URL + this.state.article.userAvatar :
                                                        this.state.article.userImage ? BASE_URL + this.state.article.userImage :
                                                        this.state.article.userProfileImage ? BASE_URL + this.state.article.userProfileImage :
                                                        this.props.user.avatar ? BASE_URL + this.props.user.avatar :
                                                        process.env.PUBLIC_URL + "assets/img/head.svg"
                                                    }
                                                    alt="Generic placeholder"
                                                />
                                            )
                                        }
                                        <Media.Body>
                                            {this.props?.location?.state?.from != 'internal' ? (
                                                <>
                                                    <div className="authore_name">
                                                        <h5>{this.state.company.companyName}</h5>
                                                    </div>
                                                    <div className="w-100">
                                                        <h6>
                                                            <span className="text-73 edit-company-article__author-name">{this.state.profile.fullName}</span>
                                                            {this.state.profile.buildingIndustryRole && (
                                                                <>
                                                                    {' '}-<span> {this.state.profile.buildingIndustryRole}</span>
                                                                </>
                                                            )}
                                                        </h6>
                                                        <div className="w-100">
                                                            {
                                                                this.state.article.product ?
                                                                    <h6 className="product_user">Product: <span>{this.state.article.product}</span></h6> : ''
                                                            }
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="authore_name internal-article-author">
                                                    <h5>
                                                        <span className="internal-article-name">{this.props.user.firstName + " " + this.props.user.lastName}</span>
                                                        {this.props.user.buildingIndustryRole && (
                                                            <span className="internal-article-branch" data-tooltip={convertBranchRole(this.props.user.buildingIndustryRole, this.context.isGerm)}>- {convertBranchRole(this.props.user.buildingIndustryRole, this.context.isGerm)}</span>
                                                        )}
                                                    </h5>
                                                </div>
                                            )}
                                        </Media.Body>
                                    </Media>
                                    <strong className="mb-2 mt-2 d-block edit-company-article__preview-title">{stripMarkdownFromTitle(this.state.article.title || '')}</strong>

                                    {this.state.article.description ? (
                                        <div className="small edit-company-article__preview-desc">
                                            <ReadMores isInternal={articleType == 1}>
                                                {this.state.article.description.replace(regex, (match, p1, p2) => {
                                                    if (p1) {
                                                        return p1;
                                                    }
                                                    return `<a href="${p2}">${p2}</a>`;
                                                })}
                                            </ReadMores>
                                        </div>
                                    ) : null}

                                 
                                </div>
                                {displayLinks && displayLinks.length > 0 &&
                                    <PlayerFeed
                                        Links={displayLinks}
                                        article={article}
                                        prev={true}
                                        isInternal={articleType == 1}
                                        onPress={(data, index) => {
                                            this.setState({ showPlayer: true, modalData: data, initialIndex: index })
                                        }}
                                    />
                                }
                                   {/* Schedule Note - Show below description when article is scheduled */}
                                   {((this.state.originalPublishTime && !this.state.originalIsPublished) || (this.state.hasUserMadeChanges && this.state.scheduleDate && this.state.scheduleTime)) && (
                                        <div 
                                            className={`schedule-note-card ${articleType == 1 ? 'schedule-note-card-internal' : 'schedule-note-card-external'}`}
                                            onClick={() => this.setState({ showScheduleModal: true })}>
                                            <div className={`schedule-note-icon-wrapper ${articleType == 1 ? 'schedule-note-icon-wrapper-internal' : 'schedule-note-icon-wrapper-external'}`}>
                                                <span className={`material-symbols-outlined schedule-note-icon ${articleType == 1 ? 'schedule-note-icon-internal' : 'schedule-note-icon-external'}`}>
                                                    schedule
                                                </span>
                                            </div>
                                            <div className="schedule-note-content">
                                                <p className="schedule-note-label">
                                                    {this.context.strings.scheduled_for_publication}
                                                </p>
                                                <p className="schedule-note-datetime">
                                                    {this.state.hasUserMadeChanges ? (
                                                        formatScheduleDateTime(this.state.scheduleDate, this.state.scheduleTime, this.context.language || (this.context.isGerm ? 'de' : 'en'), this.context.strings?.at_time)
                                                    ) : (
                                                        formatScheduleDateTime(new Date(this.state.originalPublishTime * 1000), null, this.context.language || (this.context.isGerm ? 'de' : 'en'), this.context.strings?.at_time)
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                            </div>
                        }
                    </div>
                    {
                        this.state.preview ?
                            <div className={`row justify-content-between m-0 p-2 button-group-3 preview-mode ${articleType == 1 ? 'preview-mode-internal' : ''}`}>
                                <button type="button" className={`kj-btn kj-btn--outline${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                    onClick={() => this.setState({ preview: false })}>{this.context.strings.back}</button>
                                {this.isEditingDraft() && (
                                    <button type="button" className={`kj-btn kj-btn--outline${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                        disabled={loading}
                                        onClick={this.handleSaveDraft}>
                                        {this.context.strings.save_as_draft || "Save as Draft"}
                                    </button>
                                )}
                                <button type="button" className={`kj-btn kj-btn--outline${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                    disabled={loading}
                                    onClick={() => {
                                        if (this.state.isCompanyAdmin && this.state.departments.length > 0 && articleType == 1) {
                                            if (!this.state.deptLocationId) {
                                                $crud.notify({
                                                    type: 'error',
                                                    message: "Please select department/location"
                                                })
                                            }
                                            else
                                                this.postArticle()
                                        }
                                        else if (!this.state.isCompanyAdmin || this.props?.location?.state?.from != 'internal') {
                                            this.postArticle()
                                        }
                                        else {
                                            this.postArticle()
                                        }
                                    }}>{this.isEditingDraft()
                                        ? (this.state.hasUserMadeChanges
                                            ? (this.context.strings.schedule)
                                            : (this.context.strings.post))
                                        : this.context.strings.update}</button>
                            </div>
                            :
                            <></>
                    }
                    {!this.state.preview ?
                        <div className="button-group-3">
                            <div
                                className={!this.state.originalIsPublished ? "schedule-icon-btn flex-end" : "schedule-icon-btn hidden"}
                                onClick={() => this.setState({ showScheduleModal: true })}>
                                <BsClock
                                    size={20}
                                    color={this.state.hasUserMadeChanges
                                        ? (articleType == 1 ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)')
                                        : '#999'
                                    }
                                />
                            </div>
                            {this.isEditingDraft() && (
                                <button
                                    className={`kj-btn kj-btn--outline schedule-modal-btn${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                    aria-disabled={!this.state.article.title ? "true" : undefined}
                                    onClick={this.handleSaveDraft}
                                    disabled={loading}
                                    type="button"> {this.context.strings.save_as_draft || "Save as Draft"}</button>
                            )}
                            <button
                                className={`kj-btn kj-btn--outline schedule-modal-btn${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                aria-disabled={!this.state.article.title ? "true" : undefined}
                                onClick={this.handlePreview}
                                disabled={loading}
                                type="button"> {this.context.strings.preview}</button>
                        </div>

                        :
                        <></>
                    }
                </div>
                {
                    this.state.viewProject &&
                    <ProjectListDialog isIntenal={this.props?.location?.state?.articleType == 1 ? true : false} handleClose={() => this.setState({ viewProject: false })}
                        setParam={this.setParam} buildings={this.state.buildings} />
                }

                {this.state.showDepartModal && (
                    <div className="backdrop edit-company-article__depart-backdrop">
                        <DepartLocaDialogue
                            articleType={articleType}
                            handleClose={(e) => this.setState({ showDepartModal: false })}
                            positions={this.state.departments.map(dept => ({
                                ...dept,
                                isSelected: this.state.deptLocationId && Array.isArray(this.state.deptLocationId) 
                                    ? this.state.deptLocationId.includes(dept.id)
                                    : this.state.deptLocationId == dept.id
                            }))}
                            multiple
                            onSelectMultiple={(ids, names) => {
                                this.setState({ deptLocationId: ids, names })
                            }}
                        />
                    </div>
                )}

                {/* Schedule Article Modal */}
                {this.state.showScheduleModal && (
                    <div className="schedule-modal-backdrop">
                        <div className="schedule-modal-container">
                            {/* Modal Header */}
                            <div className="schedule-modal-header">
                                <h5 className="schedule-modal-title">
                                    {this.context.strings.schedule_article_post}
                                </h5>
                                <button
                                    type="button"
                                    className="kj-btn kj-btn--icon kj-btn--neutral kj-btn--round"
                                    onClick={() => {
                                        this.setState({
                                            showScheduleModal: false
                                        });
                                    }}>
                                    <span className="material-symbols-outlined edit-company-article__schedule-close-icon">close</span>
                                </button>
                            </div>

                            {/* Modal Body */}
                            <div className="schedule-modal-body">

                                {/* Date Input */}
                                <div className="schedule-form-group">
                                    <label className="schedule-form-label">
                                        {this.context.strings.date}
                                    </label>
                                    <input
                                        type="date"
                                        className="schedule-form-input"
                                        value={this.formatDateForInput(this.state.scheduleDate)}
                                        min={this.formatDateForInput(new Date())}
                                        onChange={(e) => {
                                            const newDate = new Date(e.target.value);
                                            this.setState({
                                                scheduleDate: newDate,
                                                hasUserMadeChanges: true
                                            });
                                        }}
                                    />
                                </div>

                                {/* Time Input */}
                                <div className="schedule-form-group">
                                    <label className="schedule-form-label">
                                        {this.context.strings.time}
                                    </label>
                                    <input
                                        type="time"
                                        className="time-input-no-icon schedule-form-input"
                                        value={this.formatTimeForInput(this.state.scheduleTime)}
                                        min={(() => {
                                            const now = new Date();
                                            const isToday = this.state.scheduleDate.toDateString() === now.toDateString();
                                            
                                            // If selected date is today, set minimum time to current time
                                            if (isToday) {
                                                const currentHours = String(now.getHours()).padStart(2, '0');
                                                const currentMinutes = String(now.getMinutes()).padStart(2, '0');
                                                return `${currentHours}:${currentMinutes}`;
                                            }
                                            
                                            // If date is in the future, no time restriction
                                            return undefined;
                                        })()}
                                        onChange={(e) => {
                                            const [hours, minutes] = e.target.value.split(':');
                                            const newTime = new Date(this.state.scheduleTime);
                                            newTime.setHours(parseInt(hours), parseInt(minutes), 0);

                                            this.setState({
                                                scheduleTime: newTime,
                                                hasUserMadeChanges: true
                                            });
                                        }}
                                    />
                                </div>

                                {/* Reset Button - Only show when changes made */}
                                {this.state.hasUserMadeChanges && (
                                    <button
                                        type="button"
                                        className={`kj-btn kj-btn--outline kj-btn--sm kj-btn--block schedule-reset-btn${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                        onClick={() => {
                                            this.setState({
                                                scheduleDate: new Date(),
                                                scheduleTime: new Date(),
                                                hasUserMadeChanges: false
                                            });
                                        }}>
                                        â†» {this.context.strings.reset_selection}
                                    </button>
                                )}
                            </div>

                            {/* Modal Footer */}
                            <div className="schedule-modal-footer">
                                <button
                                    type="button"
                                    className="kj-btn kj-btn--secondary edit-company-article__btn-gap"
                                    onClick={() => {
                                        this.setState({
                                            showScheduleModal: false
                                        });
                                    }}>
                                    {this.context.strings.cancel}
                                </button>
                                {this.state.hasUserMadeChanges ? (
                                    <button
                                        type="button"
                                        className={`kj-btn kj-btn--primary${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                        onClick={this.handleScheduleConfirm}>
                                        {this.context.strings.continue}
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        disabled
                                        className="kj-btn kj-btn--outline">
                                        {this.context.strings.continue}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Discard Article Confirmation Modal */}
                <Modal
                    show={this.state.showDiscardConfirm}
                    onHide={this.cancelDiscardArticle}
                    animation={false}
                    centered
                >
                    <Modal.Body className="modal-body-relative">
                        <p>{this.context.strings.discard_article_confirm}</p>
                    </Modal.Body>
                    <Modal.Footer 
                        className={`${this.state.articleType == 1 ? "internal-article-footer" : ""} edit-company-article__discard-footer`}
                    >
                        <button
                            type="button"
                            className={`kj-btn kj-btn--outline${this.state.articleType == 1 ? ' kj-btn--internal' : ''}`}
                            onClick={this.cancelDiscardArticle}
                        >
                            {this.context.strings.cancel}
                        </button>
                        <button
                            type="button"
                            className={`kj-btn kj-btn--outline${this.state.articleType == 1 ? ' kj-btn--internal' : ''}`}
                            onClick={this.confirmDiscardArticle}
                        >
                            {this.context.strings.ok}
                        </button>
                    </Modal.Footer>
                </Modal>

                <TranslationProgressModal
                    show={this.state.showTranslationProgress}
                    articleId={this.state.translatingArticleId}
                    strings={this.context.strings}
                    onComplete={() => {
                        this.setState({ showTranslationProgress: false });
                        this.navigateAfterSave();
                    }}
                />
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    const { article, drawerOpen, isExternalSelected, selectedCompanyId, user, isDeskTopResolution } = state;
    return {
        article: article,
        drawerOpen: drawerOpen,
        isExternalSelected,
        selectedCompanyId,
        user: user,
        isDeskTopResolution: isDeskTopResolution
    };
};
const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditCompanyArticle));


// export default withRouter(EditCompanyArticle);
